import changepasswordwithtoken from './changepasswordwithtoken';
import resetpassword from './resetpassword';

export default { changepasswordwithtoken, resetpassword };
